import axiosConfig from './axiosConfig';
import { exportData } from './export';
import { createListFetcher } from './listFetchers';

// List spareparts
export const getSparepartList = createListFetcher('inventory/spareparts')

// Create sparepart
export const createSparepart = async (sparepartData) => {
    try {
        const response = await axiosConfig.post('inventory/spareparts', sparepartData, { headers: { "Content-Type": "multipart/form-data" } });
        return response;
    } catch (error) {
        throw error;
    }
};

// Update sparepart (PUT or PATCH)
export const updateSparepart = async (sparepartId, sparepartData, method = 'put') => {
    try {
        const response = await axiosConfig[method](`inventory/spareparts/${sparepartId}`, sparepartData, { headers: { "Content-Type": "multipart/form-data" } });
        return response;
    } catch (error) {
        throw error;
    }
};

// Consume sparepart stock
export const useSparepart = async (sparepartId, data) => {
    try {
        const response = await axiosConfig.post(`inventory/spareparts/${sparepartId}/use`, data);
        return response;
    } catch (error) {
        throw error;
    }
};


// Sparepart event history
export const getSparepartEvents = async (sparepartId, queryParams = {}) => {
    try {
        const response = await axiosConfig.get(`inventory/spareparts/${sparepartId}/events`, { params: queryParams });
        return response;
    } catch (error) {
        throw error;
    }
};

// Delete a sparepart image
export const deleteSparepartImage = async (sparepartId, imageId) => {
    try {
        const response = await axiosConfig.delete(`inventory/spareparts/${sparepartId}/images/${imageId}`);
        return response;
    } catch (error) {
        throw error;
    }
};

// Reorder sparepart images
export const reorderSparepartImages = async (sparepartId, orderData) => {
    try {
        const response = await axiosConfig.post(`inventory/spareparts/${sparepartId}/images/reorder`, orderData);
        return response;
    } catch (error) {
        throw error;
    }
};

// Restock sparepart quantity
export const restockSparepart = async (sparepartId, restockData) => {
    try {
        const response = await axiosConfig.post(`inventory/spareparts/${sparepartId}/restock`, restockData);
        return response;
    } catch (error) {
        throw error;
    }
};

// List sparepart tags
export const getSparepartTags = async (queryParams = {}) => {
    try {
        const response = await axiosConfig.get('inventory/spareparts/tags', { params: queryParams });
        return response;
    } catch (error) {
        throw error;
    }
};

// Inventory Metrics

// Get inventory KPI statistics
export const getInventoryKPI = async () => {
    try {
        const response = await axiosConfig.get('inventory/kpis');
        return response;
    } catch (error) {
        throw error;
    }
};


// Get inventory usage trend
export const getInventoryUsageTrend = async () => {
    try {
        const response = await axiosConfig.get('inventory/usage-trend');
        return response;
    } catch (error) {
        throw error;
    }
};

//Inventory Exports

// Export inventory as CSV
export const exportInventoryCSV = async (params) => {
    return exportData('inventory/exports/inventory', 'inventory', params);
};

// Export sparepart price history as CSV
export const exportPriceHistoryCSV = async (sparepartId, name) => {
    return exportData(
        `inventory/exports/price-history/${sparepartId}`,
        `price_history_${name}`
    );
};

// Export sparepart events as CSV
export const exportEventsCSV = async (sparepartId, name, params) => {
    return exportData(
        `inventory/exports/events/${sparepartId}`,
        `sparepart_events_${name}`,
        params
    );
};

// Export inventory as XLSX
export const exportInventoryXLSX = async (params) => {
    return exportData('inventory/exports/inventory/xlsx', 'inventory', params);
};
